// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1emdM","left":"styles_left__3_jux"};